// src/auth/permMap.js
export const P = {
  // Orders core
  ORDERS_READ:                    { resource: "orders", action: "read" },
  ORDERS_CREATE:                  { resource: "orders", action: "create" },
  ORDERS_UPDATE:                  { resource: "orders", action: "update" },
  ORDERS_DELETE:                  { resource: "orders", action: "delete" },

  // Clients on orders
  CLIENT_CREATE:                  { resource: "orders", action: "create_client" },
  CLIENT_UPDATE:                  { resource: "orders", action: "update_client" },
  CLIENT_READ:                    { resource: "orders", action: "read_client" },
  CLIENT_DELETE:                  { resource: "orders", action: "delete_client" },

  // Payments
  PAYMENT_UPDATE_STATUS:          { resource: "orders", action: "update_payment_status" }, // mark Received
  PAYMENT_CONFIRM:                { resource: "orders", action: "confirm_payment" },      // accounts

  // Marketing / design / print
  SAMPLE_DESIGN_UPDATE:           { resource: "orders", action: "update_sample_design_ready_status" },
  PARTNER_APPROVAL_UPDATE:        { resource: "orders", action: "update_approval_by_partner_status" },
  PRINT_GENERATE_FILE:            { resource: "orders", action: "generate_print_file" },
  PRINT_UPDATE_STATUS:            { resource: "orders", action: "update_print_status" },

  // Warehouse
  WH_HANDOVER_UPDATE:             { resource: "orders", action: "update_sleeve_handover_status" },
  WH_RECEIVE_UPDATE:              { resource: "orders", action: "update_sleeve_received_status" },

  // Other modules you listed:
  SLEEVES_ALL:                    { resource: "sleeves", action: "all" },
  PARTNERS_ALL:                   { resource: "partners", action: "all" },
};
